import React, { useState, useEffect } from "react";

import "./PortfolioAbout.scss";

import { ReactComponent as ArrLink } from "../../assets/svg/ArrowLink.svg";

import { Link } from "react-router-dom";

import Slide2 from "../../assets/images/Slide-2.png";
import Slide5 from "../../assets/images/Slide-5.png";
import Slide9 from "../../assets/images/Slide-9.png";
import Slide10 from "../../assets/images/Slide-10.png";

const PortfolioAbout = () => {
  const [current, setCurrent] = useState(0);
  const slides = [Slide2, Slide5, Slide9, Slide10];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(current === slides.length - 1 ? 0 : current + 1);
    }, 1500);
    return () => clearInterval(interval);
  }, [current, slides.length]);

  return (
    <>
      <section className="section portfolioHero">
        <div className="portfolioHero__container container">
          <h3>
            PROJECT <br />
            <span>Product Design</span>
          </h3>

          <h2>Drapme - your personal chauffeur provider.</h2>
        </div>
      </section>

      <section className="portfolioAbout">
        <section className="portfolioBanner">
          <article
            className="portfolioBanner__container container"
            style={{
              backgroundImage: `url(${slides[current]})`,
            }}
          ></article>
        </section>

        <article className="portfolioAbout__container container">
          <div className="portfolioAbout__container--contents">
            <div className="portfolioAbout__container--contents-left">
              <div className="contents-left-item">
                <p>CLIENT</p>
                <h3>Abiodun Owotomo</h3>
              </div>

              <div className="contents-left-item">
                <p>CATEGORY</p>
                <h3>Rideshare</h3>
              </div>

              <div className="contents-left-item">
                <p>LIVE VIEW</p>
                <Link href="/" className="flex">
                  View Website
                  <ArrLink />
                </Link>
              </div>

              <div className="contents-left-item">
                <p>TIMELINE</p>
                <h3>6 Months</h3>
              </div>

              <div className="contents-left-item">
                <p>SERVICE WE PROVIDED</p>
                <div>
                  <h3>Branding </h3>
                  <h3>User Research</h3>
                  <h3>UI Design </h3>
                  <h3>Development</h3>
                </div>
              </div>
            </div>

            <div className="portfolioAbout__container--contents-right">
              <h3>About the Project</h3>
              <p>
                Drapme is a limo brokage service which provides a chauffeur
                portal connecting people to professional chauffeurs via their
                mobile app, website and hotline.
                <br />
                <br />
                The company offers a prebooking service at a fixed rate and
                doesn&apos;t own its own fleet, but works with local chauffeur
                companies in each of its cities. Airport pickups include one
                hour of free waiting time, while all non-airport pickups include
                15 minutes.
                <br />
                <br />
                Guests can also edit or cancel their bookings for free up to one
                hour before a one-way transfer.
              </p>
            </div>
          </div>
        </article>
      </section>

      <section className="portfolioMock-up"></section>
    </>
  );
};

export default PortfolioAbout;
